import React from "react";

const Footer: React.VFC<{}> = ({}) => (
    <div className="bg-white skrwd-Footer">
        <div className="px-12 pb-20 pt-10 mt-10 md:pt-32 md:mt-32 md:max-w-3xl md:mx-auto border-t border-0 border-gray-ccc border-solid">
            <a
                href="https://sakurawada.jp"
                className="mb-9 block skrwd-Footer-Link"
            >
                <span className="text-black-darkest text-sm mr-5 skrwd-Font-RobotoMono">
                    TOP
                </span>
                <span className="text-black-lightest text-tiny align-middle skrwd-Font-HiraginoKakuGo">
                    ブランドトップ
                </span>
            </a>
            <a
                href="https://sakurawada.jp/collections/all"
                className="mb-9 block skrwd-Footer-Link"
            >
                <span className="text-black-darkest text-sm mr-5 skrwd-Font-RobotoMono">
                    PRODUCT
                </span>
                <span className="text-black-lightest text-tiny align-middle skrwd-Font-HiraginoKakuGo">
                    商品紹介
                </span>
            </a>
            <a
                href="https://sakurawada.jp/apps/know-yourself"
                className="mb-9 block skrwd-Footer-Link md:mb-20"
            >
                <span className="text-black-darkest text-sm mr-5 skrwd-Font-RobotoMono">
                    KNOW YOURSELF
                </span>
                <span className="text-black-lightest text-tiny align-middle skrwd-Font-HiraginoKakuGo">
                    自分の体質を知る
                </span>
            </a>
            <hr className="mb-10 md:mb-20" />
            <div
                className="text-black-lightest text-[8px]"
                style={{ letterSpacing: "0.3em" }}
            >
                © SAKURA WADA 2021
            </div>
        </div>
    </div>
);

export default Footer;
